import src from "IMAGE";
export default { src, width: 800, height: 200, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/webp;base64,UklGRk4AAABXRUJQVlA4TEEAAAAvB0AAAM1VICICHggGDQAAAIBEgAkHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAAICEEvAAAAEZHRn2JO9hmpDgA="};
